import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";
import { getLineItemQuantityAlreadyValidatedByLogistician } from "./get-line-item-quantity-already-validated-by-logistician";

type UseLineItemValidatedMaxQuantityParams = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * Returns the maximum quantity that a merchant can treat when workflow logistician is activated.
 *
 * The calculation is:
 * - Takes the total quantity validated by logistician
 * - Subtracts the quantity already validated by merchant
 * - Returns the remaining quantity eligible for merchant validation
 *
 * @example
 * If a line item was purchased 4 times:
 * - Logistician validates 2 items
 * - Merchant validates 1 item
 * - Result: 1 item remaining that can be treated by merchant (2 - 1 = 1)
 */
export function getLineItemReadyToBeTreatedByMerchantSelectableQuantityWithWorkflowLogistician({
  lineItem,
}: UseLineItemValidatedMaxQuantityParams) {
  const quantityValidatedByLogistician =
    getLineItemQuantityAlreadyValidatedByLogistician({
      lineItem,
    });

  return quantityValidatedByLogistician;
}
